export function apiUrl(state) {
    return state.apiUrl;
}

export function isDimmed(state) {
    return state.dimmed;
}

export function isLocked(state) {
    return state.locked;
}

export function user(state) {
    return state.user;
}

export function organisation(state) {
    return state.organisation;
}

export function trees(state) {
    return state.trees;
}

export function activeTree(state) {
    return state.activeTree;
}

export function manipulatedData(state) {
    return state.manipulatedData;
}

export function isMobileNav(state) {
    return state.isMobileNav;
}
